// src/Services/manualClientTime.service.js
import config from "../config";
import selectedEnvironment from "../env";

const API_URL = `${config[selectedEnvironment].API_URL}/ManualClientTimes`;

const Create = async (payload, authToken) => {
    const response = await fetch(`${API_URL}/Create`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
    return response;
};

const Update = async (id, payload, authToken) => {
    const response = await fetch(`${API_URL}/Update/${id}`, {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
    return response;
};

const Delete = async (id, authToken) => {
    const response = await fetch(`${API_URL}/Delete/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
        },
    });
    return response;
};

const GetById = async (id, authToken) => {
    const response = await fetch(`${API_URL}/Get/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
        },
    });
    return response;
};

/**
 * Filter manual client times.
 * @param {{ accountantId: string, userIds?: string[], caseId?: string, year?: number, month?: number, day?: number, startUtc?: string, endUtc?: string }} filter
 * @param {string} authToken
 */
const Filter = async (filter, authToken) => {
    const response = await fetch(`${API_URL}/filter`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(filter),
    });
    return response;
};

const ManualClientTimeService = {
    Create,
    Update,
    Delete,
    GetById,
    Filter,
};

export default ManualClientTimeService;
